module.exports = __webpack_public_path__ + "img/logo-its-smaller.4e2b3408.png";